import React, { createContext, useEffect, useState } from "react";
import { message, Tabs } from "antd";
import moment from "moment";
import StaticChart from "./components/StaticChart";
import DynamicChart from "./components/DynamicChart";
import PList from "./components/StaticChart/PList";
import performanceManagementService from "@services/performanceManagement.service";
import planningService from "@services/planning.service";

const { TabPane } = Tabs;

export const P1P2Contenxt = createContext({
  dataSource: {
    P1: {
      loading: false,
      chart: [],
      bar: [],
      list: [],
      list2: [],
    },
    P2: {
      loading: false,
      chart: [],
      bar: [],
      list: [],
      list2: [],
    },
  },
  kpis: [],
  provinces: [],
});

const P1P2 = () => {
  const [loading, setLoading] = useState(false);
  const [dataSourceP1, setDataSourceP1] = useState({
    loading: false,
    data: {
      chart: [],
      bar: [],
      list: [],
      list2: [],
    },
  });
  const [dataSourceP2, setDataSourceP2] = useState({
    loading: false,
    data: {
      chart: [],
      bar: [],
      list: [],
      list2: [],
    },
  });

  const [kpis, setKpis] = useState({ loading: false, data: [], error: null });
  const [provinces, setProvinces] = useState({
    loading: false,
    data: [],
    error: null,
  });

  async function fetchProvinces() {
    setProvinces({ ...provinces, loading: true });
    try {
      const res = await planningService.fetchProvinces();
      setProvinces({
        ...provinces,
        loading: false,
        data: [
          ...res.data.map((p) => ({
            label: p,
            value: p,
          })),
        ],
      });
    } catch (error) {
      console.log(error);
      setProvinces({ ...provinces, loading: false, error: error });
    }
  }

  async function fetchKpis() {
    setKpis({ ...kpis, loading: true });

    try {
      // const res = await atollService.fetchKpis();
      setKpis({
        ...kpis,
        loading: false,
        data: [
          "4G_THR",
          "4G_CSSR_PS",
          "3G_THR",
          "3G_DCR_CS",
          "3G_CSSR_CS",
          "2G_DCR",
          "2G_CSSR",
        ].map((s) => ({ label: s, value: s })),
      });
    } catch (error) {
      console.log(error);
      setKpis({ ...kpis, loading: false, error: error });
    }
  }

  const fetcherP1 = async () => {
    setDataSourceP1({ ...dataSourceP1, loading: true });
    try {
      const { data } = await performanceManagementService.fetchP1P22({
        technology: "all",
        priority: "P1",
        region: "all",
        subregion: "all",
        province: "all",
        kpi: "all",
        park_status: "",
        datetime: [
          moment().hours(0).minutes(0).seconds(0).valueOf(),
          moment().hours(0).minutes(0).seconds(0).valueOf(),
        ],
      });

      setDataSourceP1({ ...dataSourceP1, loading: false, data });
    } catch (error) {
      message.error("Action has error",20);
      setDataSourceP1({ ...dataSourceP1, loading: false });
    }
  };

  const fetcherP2 = async () => {
    setDataSourceP2({ ...dataSourceP2, loading: true });
    try {
      const { data } = await performanceManagementService.fetchP1P22({
        technology: "all",
        priority: "P2",
        region: "all",
        subregion: "all",
        province: "all",
        kpi: "all",
        park_status: "",
        datetime: [
          moment().hours(0).minutes(0).seconds(0).valueOf(),
          moment().hours(0).minutes(0).seconds(0).valueOf(),
        ],
      });

      setDataSourceP2({ ...dataSourceP2, loading: false, data });
    } catch (error) {
      message.error("Action has error",20);
      setDataSourceP2({ ...dataSourceP2, loading: false });
    }
  };

  useEffect(() => {
    fetchProvinces();
    fetchKpis();
    fetcherP1();
    fetcherP2();
  }, []);

  return (
    <div className="p-5 h-full">
      <div className="bg-white border border-gray-200 rounded-md flex-grow">
        <P1P2Contenxt.Provider
          value={{
            dataSource: { P1: dataSourceP1, P2: dataSourceP2 },
            loading,
            provinces,
            kpis,
          }}
        >
          <Tabs defaultActiveKey="1" centered>
            <TabPane tab="Static Chart P1" key="1">
              <StaticChart type="P1" />
              <PList type="P1" />
            </TabPane>
            <TabPane tab="Static Chart P2" key="2">
              <StaticChart type="P2" />
              <PList type="P2" />
            </TabPane>
            <TabPane tab="Dynamic Chart" key="3">
              <DynamicChart />
            </TabPane>
          </Tabs>
        </P1P2Contenxt.Provider>
      </div>
    </div>
  );
};

export default P1P2;
